import {useMutation} from '@tanstack/react-query';

import {provisionAccount, provisionAccountWithLoginID, validateAccount} from 'features/CreateAccount/api-services';
import {ProvisioningResponse, ValidationResponse} from 'features/CreateAccount/types';
import {ProvisioningError, ProvisioningWithLoginIDError, ValidationError} from 'features/CreateAccount/types/error';
import {QUERY_KEY} from 'hooks/queries';

export const useProvisionAccountMutation = () =>
  useMutation<ProvisioningResponse, ProvisioningError, Parameters<typeof provisionAccount>[0]>({
    mutationFn: provisionAccount,
    mutationKey: [QUERY_KEY.CREATE_ACCOUNT, QUERY_KEY.PROVISION_ACCOUNT]
  });

export const useProvisionAccountWithLoginIDMutation = () =>
  useMutation<ProvisioningResponse, ProvisioningWithLoginIDError, Parameters<typeof provisionAccountWithLoginID>[0]>({
    mutationFn: provisionAccountWithLoginID,
    mutationKey: [QUERY_KEY.CREATE_ACCOUNT, QUERY_KEY.PROVISION_ACCOUNT_WITH_LOGIN_ID]
  });

export const useValidateAccountMutation = () =>
  useMutation<ValidationResponse, ValidationError, Parameters<typeof validateAccount>[0]>({
    mutationFn: validateAccount,
    mutationKey: [QUERY_KEY.CREATE_ACCOUNT, QUERY_KEY.VALIDATE_ACCOUNT]
  });
